var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"ds-text-2xs md:ds-text-xs text-white min-w-28"},[_vm._v(" "+_vm._s(_vm.creatorDescription)+" skipped this athlete "+_vm._s(_vm.createdDate)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }